import BlVoucherCardMv from './BlVoucherCardMv.vue'

BlVoucherCardMv.install = function(Vue) {
  Vue.component(BlVoucherCardMv.name, BlVoucherCardMv)
}

export default BlVoucherCardMv
